export interface IUnderground {
  lineColor: string;
  path: IUndergroundPath;
  stationName: string;
  undergroundType: EUndergroundType;
}

export interface IUndergroundPath {
  pathType: EPathType;
  text: string;
}

export enum EUndergroundType {
  MSK = 'msk',
  SPB = 'spb',
  EKB = 'ekb',
  KZN = 'kzn',
  NOVOSIB = 'novosib',
  SAM = 'sam',
  NN = 'nn',
}

export enum EPathType {
  Walk = 'walk',
  Car = 'car',
  Bus = 'bus',
}
